module.exports = __webpack_public_path__ + "img/Stuttgart.f8ef7ca8.png";